import { config } from '../../config.js';

import type { ProviderAccessMap } from '@vgtv/svp-access/lib/access_mappings.js';
import type { Provider } from '@vgtv/api-client';

const LOGIN_ACCESSES = ['premium', 'login'];
const SUBSCRIPTION_ACCESSES = ['plus', 'sport', 'total'];

const hasIntersection = (a: string[], b: string[]) =>
  a.some((item) => b.includes(item));

export const hasValidSubscriptionAccess = (
  accesses: ProviderAccessMap[Provider][]
) => hasIntersection(SUBSCRIPTION_ACCESSES, accesses);

export const hasValidLoginAccess = (accesses: ProviderAccessMap[Provider][]) =>
  hasIntersection(LOGIN_ACCESSES, accesses);

export const getSubscriptionLabel = (accesses: string[]) => {
  switch (config.provider) {
    case 'vgtv': {
      if (accesses.includes('sport')) {
        return 'VG+ Sport';
      }
      if (accesses.includes('plus')) {
        return 'VG+';
      }
      break;
    }
    case 'ab': {
      if (accesses.includes('plus')) {
        return 'Pluskund';
      }
      break;
    }
  }
};
